'use client';

import { Body } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { ShopProductsList } from '../../../components/ProductList';
import { LikedProductsEmptyState } from '../EmptyState';

import styles from './styles.module.css';

import { type ShopProfileSection } from '@/modules/activityTracker/constants';
import { useLikedProducts } from '@/modules/likes/hooks/useLikedProducts';
import { getObjectsFromPages } from '@/modules/pagination/getObjectsFromPages';
import { useShopByUsername } from '@/modules/shop/hooks/useShopByUsername';

type Props = {
  activeTab?: ShopProfileSection;
};

export function LikedProducts({ activeTab }: Props = {}) {
  const tShop = useTranslations('shop');
  const { data: sellerData } = useShopByUsername();
  const sellerId = sellerData?.data.id;
  const username = sellerData?.data.username;

  const {
    data,
    isError,
    isFetchingNextPage,
    isLoading,
    fetchNextPage,
    hasNextPage,
  } = useLikedProducts({ sellerId });

  const products = getObjectsFromPages(data);

  return (
    <section>
      {username && (
        <Body variant="sm-bold" className={styles.headingText}>
          {tShop('SellersLikes', {
            capitalizedShopName:
              username.charAt(0).toUpperCase() + username.slice(1),
          })}
        </Body>
      )}
      <ShopProductsList
        onEndReached={fetchNextPage}
        hasMore={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        products={products}
        isError={isError}
        isLoading={isLoading}
        EmptyState={() => <LikedProductsEmptyState />}
        activeTab={activeTab}
      />
    </section>
  );
}
